/* Exact-product public widget adapter. No shop crawl, tokens, writes or timers.
 * One bounded GET at hydration/open; later pages require a shopper action.
 * A mixed/grouped wrapper NEVER qualifies its count. Unknown is not zero.
 */
(() => {
  'use strict';
  if (window.MiniamiReviewMetrics) return;
  const sessions = new Map();
  let held = false;
  const uuid = x => typeof x === 'string' && /^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(x);
  function path(value) {
    if (typeof value !== 'string' || !value.startsWith('/products/') || /[?#\\]/.test(value) || value.includes('//') || /%2f|%5c/i.test(value)) return null;
    try { const decoded = decodeURIComponent(value); return /^\/products\/[^/?#\\]+$/.test(decoded) && !/%/.test(decoded) ? decoded : null; } catch (_) { return null; }
  }
  const decimal = (sum,count) => count ? (Math.floor((sum * 20 + count) / (2 * count)) / 10).toFixed(1) : null;
  function photo(value) {
    try { const u = new URL(value); return u.protocol === 'https:' && u.hostname === 'review-images.judgeme.com' && !u.username && !u.password ? u.href : null; } catch (_) { return null; }
  }
  function text(html) {
    const d = new DOMParser().parseFromString(String(html || ''), 'text/html');
    d.querySelectorAll('script,style,iframe').forEach(e => e.remove());
    d.querySelectorAll('br').forEach(e => e.replaceWith('\n'));
    d.querySelectorAll('p').forEach(e => e.append('\n'));
    return d.body.textContent.replace(/\n$/, '');
  }
  function identify(root) {
    const id = root.dataset.productId || root.dataset.reviewProductId;
    const canonical = path(root.dataset.productUrl || root.dataset.reviewProductUrl);
    const token = root.dataset.productToken || root.dataset.reviewProductToken || '';
    if (!/^[1-9]\d*$/.test(id || '') || !canonical) throw Error('identity');
    return {id, canonical, token};
  }
  function session(root) {
    const identity = identify(root), key = JSON.stringify(identity);
    if (!sessions.has(key)) sessions.set(key, {identity, rows:new Map(), streams:null, mediaRows:new Map(), mediaStreams:null, aggregate:null, at:0, pending:null, marker:null, requests:0, generation:0});
    return sessions.get(key);
  }
  function paging(d, media) {
    const defs = media ? [['reviews','pagination']] : [['primary_language_reviews','primary_language_pagination'],['other_language_reviews','other_language_pagination']];
    return defs.map(([rows,key]) => {
      const m = d[key];
      if (!m || !Number.isInteger(m.current_page) || m.current_page < 1 || !Number.isInteger(m.total_pages) || m.total_pages < 0 || !Array.isArray(d[rows]) || (m.total_pages === 0 && d[rows].length)) throw Error('pagination');
      return {rows:d[rows], page:m.current_page, pages:m.total_pages, key, rowsKey:rows};
    });
  }
  function histogram(d) {
    const count = Number(d.number_of_reviews), bins = [0,0,0,0,0];
    if (!Number.isSafeInteger(count) || count < 0 || !Array.isArray(d.histogram) || d.histogram.length !== 5) return null;
    const seen = new Set();
    for (const b of d.histogram) {
      if (!Number.isInteger(b.rating) || b.rating < 1 || b.rating > 5 || seen.has(b.rating) || !Number.isInteger(b.frequency) || b.frequency < 0) return null;
      seen.add(b.rating); bins[b.rating - 1] = b.frequency;
    }
    const sum = bins.reduce((n,c,i) => n+c*(i+1),0);
    if (bins.reduce((n,c) => n+c,0) !== count || (count && Math.abs(sum/count - Number(d.average_rating)) > .0051)) return null;
    return {count,sum,bins};
  }
  function own(r, s) {
    const i = s.identity;
    return (r.product_id==null || String(r.product_id)===i.id) && r.is_shop_review!==true && path(r.product_url) === i.canonical && (!i.token || String(r.encoded_product_id || '') === i.token)
      && r.is_for_product_from_group !== true && r.is_for_product_from_bundle !== true;
  }
  function normalize(r) {
    if (!uuid(r.uuid) || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5) throw Error('row');
    const attachments = (Array.isArray(r.pictures_urls) ? r.pictures_urls : []).map(p => ({url:photo(p.original || p.huge || p.small || p.compact), thumbnail:photo(p.small || p.compact || p.original || p.huge)})).filter(p => p.url && p.thumbnail);
    return {id:r.uuid,rating:r.rating,body:typeof r.body === 'string' ? r.body : text(r.body_html),title:r.title || '',name:r.is_anonymous_reviewer ? 'Anonymous' : r.reviewer_name || '',verified:r.verified_buyer === true,date:Number.isFinite(Date.parse(r.created_at)) ? r.created_at : null,country:r.country_code_show_flag !== false ? r.location_country || '' : '',attachments};
  }
  function render(s) {
    const a = s.aggregate;
    if (!a) return;
    const label = n => Number(n).toLocaleString('en-US');
    document.querySelectorAll('[data-miniami-review-metric]').forEach(metric => {
      if (metric.dataset.reviewProductId !== s.identity.id || path(metric.dataset.reviewProductUrl) !== s.identity.canonical) return;
      const rating = decimal(a.sum,a.count), recap = metric.dataset.reviewPresentation === 'recap';
      Object.assign(metric.dataset,{reviewCount:String(a.count),reviewSum:String(a.sum),reviewAverage:rating || '',reviewSummaryState:'qualified-provider-cached',reviewSourceAt:String(Math.floor(s.at/1000))});
      const numeric = metric.querySelector('[data-review-numeric]');
      if (numeric) numeric.textContent = recap ? `${label(a.count)} ${a.count === 1 ? 'review' : 'reviews'}` : a.count ? `${rating} · ${label(a.count)} ${a.count === 1 ? 'review' : 'reviews'}` : 'No reviews yet';
      let score = metric.querySelector('[data-review-score]');
      if (recap && a.count && !score) { score = document.createElement('span'); score.dataset.reviewScore=''; score.className='miniami-product-review__score'; metric.insertBefore(score,numeric); }
      if (score) { score.hidden = !a.count; score.textContent = rating || ''; }
      metric.querySelectorAll('.miniami-product-review__aggregate-star,.miniami-source-review__stars').forEach(e => {e.hidden = !a.count;e.setAttribute('aria-label',`${rating || 0} out of 5 stars`);});
      metric.removeAttribute('title');
    });
    document.dispatchEvent(new CustomEvent('miniami:product-reviews-updated',{detail:{id:s.identity.id}}));
  }
  async function load(s, {more=false,media=false,signal} = {}) {
    if (held) throw Error('source hold');
    if (s.pending) { await s.pending; if (!more) return s; }
    if (!more && s.at && Date.now()-s.at < 1200000 && (!media || s.mediaStreams)) return s;
    const generation = ++s.generation;
    s.pending = (async () => {
      const oldStreams = media ? s.mediaStreams : s.streams;
      const cursor = more && oldStreams ? oldStreams.find(m => m.page < m.pages) : null;
      if (more && !cursor) return s;
      const u = new URL('https://cdn.judge.me/reviews/reviews_for_widget');
      u.search = new URLSearchParams({shop_domain:'gigdmw-30.myshopify.com',platform:'shopify',product_id:s.identity.id,per_page:'3',primary_language:'en',translation_locale:'en',widget_theme:'default',page:String(cursor?.key === 'other_language_pagination' ? 1 : cursor ? cursor.page+1 : 1),...(cursor?.key === 'other_language_pagination' ? {other_language_page:String(cursor.page+1),skip_primary_language:'true'} : {}),...(media ? {show_media_only:'true'} : {})});
      const controller = new AbortController(), abort = () => controller.abort();
      signal?.addEventListener('abort',abort,{once:true});
      if(signal?.aborted)controller.abort();
      const timeout = setTimeout(abort,8000);
      try {
        const response = await fetch(u,{method:'GET',credentials:'omit',cache:'default',signal:controller.signal});
        s.requests++;
        if ([401,403,429].includes(response.status)) {held=true;throw Error('source hold');}
        if (!response.ok) throw Error('source unavailable');
        const d = await response.json();
        if (generation !== s.generation || controller.signal.aborted) throw Error('cancelled');
        if (String(d.product_external_id) !== s.identity.id || (d.encoded_product_id && s.identity.token && String(d.encoded_product_id) !== s.identity.token)) throw Error('wrapper identity');
        const streams = paging(d,media), aggregate = media ? null : histogram(d);
        if (!media && !aggregate) throw Error('aggregate schema');
        const marker = media ? null : JSON.stringify(aggregate); // Provider metafield_updated_at is response-generation time, not a modification version; ETag is page-specific.
        if (more && !media && marker !== s.marker) {s.rows.clear();s.streams=null;s.aggregate=null;s.at=0;throw Error('source changed');}
        const map = new Map(more ? (media ? s.mediaRows : s.rows) : []);
        let foreign = !media && Boolean(d.product_group_id);
        for (const stream of streams) {
          if (cursor && stream.key !== cursor.key) continue;
          if (cursor && (stream.page !== cursor.page+1 || stream.pages !== cursor.pages)) throw Error('pagination changed');
          for (const raw of stream.rows) {
            if (!own(raw,s)) {foreign=true;continue;}
            const row = normalize(raw), previous = map.get(row.id);
            if (previous && JSON.stringify(previous) !== JSON.stringify(row)) throw Error('conflicting duplicate');
            map.set(row.id,row);
          }
        }
        const updated = cursor ? oldStreams.map(m => m.key === cursor.key ? streams.find(x => x.key === m.key) : m) : streams;
        if (media) {s.mediaRows=map;s.mediaStreams=updated;}
        else {
          s.rows=map;s.streams=updated;if(!more){s.mediaRows.clear();s.mediaStreams=null;}s.marker=marker;s.foreign=more ? s.foreign || foreign : foreign;
          const closed = updated.every(m => m.page >= m.pages);
          const sum = [...map.values()].reduce((n,r) => n+r.rating,0);
          // Without approved ungrouping provenance, only a closed, exact unique
          // all-star population can qualify a wrapper. Partial pages never do.
          s.aggregate = closed && !s.foreign && map.size === aggregate.count && sum === aggregate.sum ? aggregate : null;
          s.at=Date.now();s.source={kind:'installed-judgeme-product-widget',fetchedAt:new Date(s.at).toISOString(),sourceUpdatedAt:d.metafield_updated_at || null,cacheMaxAge:response.headers.get('Cache-Control'),etag:response.headers.get('ETag'),qualification:s.aggregate ? 'qualified_provider_cached' : 'unqualified_group_or_partial'};
          render(s);
        }
        return s;
      } finally {clearTimeout(timeout);signal?.removeEventListener('abort',abort);}
    })().finally(() => {s.pending=null;});
    return s.pending;
  }
  // Live Judge.me window (owner ask 2026-11-01): the app-maintained metafield is
  // the same window Judge.me renders on this product page, so it owns the dialog
  // when the shared Liquid gate admitted it and the row set validates here too.
  // Anything inconsistent returns null and the dated checkpoint stays in charge.
  function live(root, s) {
    const tpl = root.querySelector('template[data-product-review-live]');
    if (!tpl) return null;
    const d = tpl.dataset;
    if (d.productId !== s.identity.id || path(d.productUrl) !== s.identity.canonical) return null;
    if (!Number.isFinite(Date.parse(d.metafieldUpdatedAt || ''))) return null;
    const int = v => (typeof v === 'string' && /^\d+$/.test(v) ? Number(v) : NaN);
    const rowCount = int(d.rowCount), total = int(d.totalCount), pages = int(d.primaryPages), page = int(d.primaryPage), perPage = int(d.perPage);
    if (![rowCount, total, pages, page, perPage].every(Number.isInteger)) return null;
    if (page < 1 || pages < 1 || page > pages || perPage < 1 || rowCount > perPage || rowCount > total || rowCount < 1) return null;
    const average = Number(d.averageRating);
    if (!Number.isFinite(average) || average < 0 || average > 5) return null;
    // The metafield histogram is 5★→1★; every consumer here wants 1★→5★.
    const bins = (d.histogram || '').split(',').map(Number).reverse();
    if (bins.length !== 5 || bins.some(n => !Number.isInteger(n) || n < 0) || bins.reduce((n, c) => n + c, 0) !== total) return null;
    const script = tpl.content.querySelector('script[type="application/json"]');
    if (!script) return null;
    let raw;
    try { raw = JSON.parse(script.textContent); } catch (_) { return null; }
    if (!Array.isArray(raw) || raw.length !== rowCount) return null;
    const rows = new Map();
    for (const r of raw) {
      if (!r || !uuid(r.uuid) || !Number.isInteger(r.rating) || r.rating < 1 || r.rating > 5) return null;
      if (rows.has(r.uuid)) return null;
      let row;
      try { row = normalize(r); } catch (_) { return null; }
      // Keep the row's own product for grouped windows; never re-attribute it.
      row.product = typeof r.product_title === 'string' ? r.product_title : '';
      row.productPath = path(r.product_url);
      row.own = own(r, s);
      rows.set(row.id, row);
    }
    return {
      rows: [...rows.values()].sort((a, b) => (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0)),
      live: true, source: 'judgeme-metafield', updatedAt: d.metafieldUpdatedAt,
      scope: d.scope === 'group' ? 'group' : 'product',
      count: total, average, bins, page, pages, perPage,
      date: String(d.metafieldUpdatedAt).slice(0, 10), savedLoaded: false
    };
  }
  // C1: a bounded historical presentation bank, never an aggregate/provider cursor.
  // Keep it separate from session.rows so a partial/grouped window cannot acquire
  // the checkpoint's count or claim closure. Current qualified UUIDs win whole.
  function presentation(root,s) {
    if (Number(window.Shopify?.theme?.id)!==205457097035 || !['main','published','unpublished'].includes(window.Shopify?.theme?.role)) return null;
    if(s.identity.canonical!=='/products/'+root.dataset.productHandle)return null;
    const window_ = live(root,s);
    if (window_) return window_;
    const bank=root.querySelector('template[data-product-review-checkpoint]');
    if (!bank || bank.dataset.productId!==s.identity.id || path(bank.dataset.productUrl)!==s.identity.canonical || bank.dataset.sourceSha256!=='6fba8a1dc05017e1dcc8c15fdf989e08383c61aac69d7e11d465c50038207505') return null;
    const result=new Map();
    const admit=(template,historical=false)=>{
      if(!template || template.dataset.productId!==s.identity.id || path(template.dataset.productUrl)!==s.identity.canonical)return;
      const rows=historical ? (template.savedRows || (template.content.querySelector('script[type="application/json"]') ? JSON.parse(template.content.querySelector('script[type="application/json"]').textContent) : null)) : JSON.parse(template.content.querySelector('script[type="application/json"]').textContent);
      if(rows===null)return;
      if(!Array.isArray(rows)||rows.length>1243)throw Error('checkpoint bound');
      for(const raw of rows){
        // A supplied native ID is authoritative; a matching URL cannot repair it.
        if(raw.product_id!=null && String(raw.product_id)!==s.identity.id)continue;
        if(!own(raw,s) || raw.is_shop_review===true)continue;
        try {const row=normalize(raw);if(historical&&result.has(row.id))throw Error('checkpoint duplicate');result.set(row.id,row);}catch(error){if(historical)throw error;}
      }
    };
    admit(bank,true);admit(root.querySelector('template[data-product-review-current]'));
    for(const row of s.mediaRows.values())result.set(row.id,row);
    for(const row of s.rows.values())result.set(row.id,row);
    return {rows:[...result.values()].sort((a,b)=>(Date.parse(b.date)||0)-(Date.parse(a.date)||0)),date:bank.dataset.sourceDate,savedLoaded:Array.isArray(bank.savedRows)};
  }
  async function loadPresentation(root,s) {
    const bank=root.querySelector('template[data-product-review-checkpoint]');
    if(!bank || bank.savedRows)return presentation(root,s);
    if(bank.pending)return bank.pending;
    bank.pending=(async()=>{
      if(bank.dataset.productId!==s.identity.id||path(bank.dataset.productUrl)!==s.identity.canonical||bank.dataset.productToken!==(s.identity.token||bank.dataset.productToken))throw Error('checkpoint identity');
      const u=new URL(bank.dataset.assetUrl,location.href);
      if(u.protocol!=='https:'||!['cdn.shopify.com',location.hostname].includes(u.hostname)||!u.pathname.endsWith('/miniami-review-saved-'+s.identity.id+'.json')||u.username||u.password)throw Error('checkpoint origin');
      const response=await fetch(u,{credentials:'omit',cache:'force-cache'});if(!response.ok)throw Error('checkpoint unavailable');
      const bytes=await response.arrayBuffer();if(bytes.byteLength>1100000)throw Error('checkpoint bytes');
      const hash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',bytes))].map(x=>x.toString(16).padStart(2,'0')).join('');if(hash!==bank.dataset.assetSha256)throw Error('checkpoint integrity');
      const rows=JSON.parse(new TextDecoder().decode(bytes));if(!Array.isArray(rows)||rows.length!==Number(bank.dataset.rowCount)||rows.length>1243)throw Error('checkpoint count');
      const identity={...s,identity:{...s.identity,token:s.identity.token||bank.dataset.productToken}};
      const seen=new Set();for(const raw of rows){if(!own(raw,identity)||seen.has(raw.uuid))throw Error('checkpoint row identity');normalize(raw);seen.add(raw.uuid);}
      bank.savedRows=rows;return presentation(root,s);
    })().finally(()=>{bank.pending=null;});return bank.pending;
  }
  window.MiniamiReviewMetrics = {path,decimal,photo,session,load,render,identify,live,presentation,loadPresentation};
})();
